define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi",
	"csi/_base/underscore",
	"csi/def",
	"csi/locale",
	"csi/reflection"
], function(declare,Memory,csi,_,def,locale,reflection) {

	return declare(Memory, {
		HTML: "Html",
		TABS: "Tabs",

		// String: root node type whose root view will be traversed
		_rootNodeType: null,
		
		// String: root view Id to traverse
		_rootViewId: null,

		constructor: function() {
			this._traverse(reflection.getClass(this._rootNodeType), this._rootViewId, null);
		},

		_traverse: function(/*Class*/rc, /*String*/viewId, /*Object?*/parent, /*Boolean*/bSkip) {
			var	defView = def.getClassViewDef(rc, viewId);
			if (!defView) return null;

			// if the same view is encountered more than once, then skip
			var	nodeType = rc.getType();
			var	key = def.composeViewKey(defView.m_id, nodeType, this._rootNodeType);
			if (this.get(key)) return null;

			// create item and look for child views based on view type
			var	viewType = defView.getType();
			var	rcTarget = defView.getPageClass(rc);

			var	name, children;
			if (parent) {
				name = locale.getResolver({typeContext:nodeType, bUseDefault: false}).getTypeView(nodeType, viewId);
			} else {
				name = locale.resource("ViewConfigurationRoot");
			}

			var	item = {
			    id:      key,
			    name :   (name == null) ? viewId : name,
                target : rcTarget ? locale.type(rcTarget.getType()) : "",

                parent:     parent ? parent.id : null,
                children:   null,

                good:          false,
                better:        false,
                best:          false,
                development:   false
			};

			if (viewType == this.TABS) {
				children = csi.transform(defView.tabs, function(tab) {
					return this._traverse(tab.getRootNodeClass(rc), tab.m_idView, item, false);
				}, this);
			} else if ((viewType == this.HTML) && !defView.isSlim()) {
				children = csi.transform(defView.getViewRefs(), function(viewRef) {
					return this._traverse(viewRef.getReferencedClass(rc), viewRef.m_id, item, false);
				}, this);
			} else {
				// handle switchboard views
				if (rcTarget && defView.idContentView) {
					var	content = this._traverse(rcTarget, defView.idContentView, item, true);
					if (content && content.children && !content.target) {
						// make child views of content view appear as children of switchboard view - unless it is also switchboard (i.e. Artwork)
						_.each(content.children, function(child) {
							child.parent = item.id;
						});

						item.children = content.children;
					}
				}
			}

			if (children && children.length) {
				item.children = children;
			}

			if (!bSkip) {
				this.add(item);
			}

			return item;
		},

		getChildren: function(item, options) {
			return item.children;
		},

		mayHaveChildren: function(object) {
			return object.children;
		}
	});
});
